require('./brokerMainStocksView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
// @components
const BrokerMainStocksSelector = require('components/broker/brokerMainStocksSelector/brokerMainStocksSelector');
const BrokerMainStocksResultsList = require('components/broker/brokerMainStocksResultsList/brokerMainStocksResultsList');
const BrokerRiskInformationBox = require('components/broker/brokerRiskInformationBox/brokerRiskInformationBox');

// @ actions
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

// @constants
const { BROKER_MAIN_STOCKS_VIEW_MAX_ROWS, MYPROFILE_BROKER_EXPLORE_STOCKS_URL, BROKER_RISK_TYPE_SIX } = require('constants/index');

class BrokerMainStocksView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleSelectorChange = this.handleSelectorChange.bind(this);
        this.requestIndexes = this.requestIndexes.bind(this);
        this.requestStocks = this.requestStocks.bind(this);

        this.state = {
            selectedMarket: props.match.params.marketId || '',
            breadcrumb: []
        };
    }

    componentDidMount() {
        this.requestIndexes();
        this.makeBreadcrumb();
    }

    componentDidUpdate(prevProps) {
        const selectedMarket = this.state.selectedMarket;
        const { immBrokerExchangeIndexes } = this.props;

        // (Andres): I am checking that the old prop is false, so we make sure this executes only one time.
        // We don't need this after every change in the dropdown
        if (!prevProps.immBrokerExchangeIndexes.get('hasBeenFetched') && immBrokerExchangeIndexes.get('hasBeenFetched') && selectedMarket) {
            this.requestStocks(selectedMarket)
        }
    }

    componentWillUnmount() {
        this.props.resetShowMoreSelectedTab();
    }

    handleSelectorChange(params) {
        const { immBrokerExchangeIndexes, getRisersAndFallers, history } = this.props;
        const { selectedMarket } = params;

        this.setState({
            selectedMarket: selectedMarket
        }, () => {
            history.push(`/myprofile/broker/mainStocks/${selectedMarket}`);
        });

        const selectedItem = immBrokerExchangeIndexes.get('indexesPlayers').find(item => item.get('spcSymbol') === selectedMarket);

        if (!selectedItem) {
            return;
        }

        getRisersAndFallers({
            exchangeId: selectedItem.get('exchangeId'),
            spcSymbol: selectedItem.get('spcSymbol'),
            market: selectedMarket,
            resultsAmount: BROKER_MAIN_STOCKS_VIEW_MAX_ROWS,
            byVolume: { risers: true, fallers: false },
            byPercentage: { risers: true, fallers: true }
        });
    }

    makeBreadcrumb() {
        const {immTodaysMainStocks } = this.props;
        const prevPage = immTodaysMainStocks.get('isFrom');
        let breadcrumbData = [];
        const BCInvestment = {
            text: formatText('breadcrumb-brokerInvestments'),
            url: '/myprofile/broker'
        };
        const BCMainStocks = {
            text: formatText('broker-mainStocksTitle'),
            url: ''
        }
        const BCMarket = {
            text: formatText('breadcrumb-brokerMarkets'),
            url: '/myprofile/broker/markets'
        };
        const BCStocks = {
            text: formatText('stocks-stocks'),
            url: '/myprofile/broker/stocks'
        }
        breadcrumbData.push(BCInvestment);
        if (prevPage.includes(BCMarket.url)) {
            breadcrumbData.push(BCMarket);
        }
        if (prevPage.includes(BCStocks.url)) {
            breadcrumbData.push(BCStocks);
        }
        breadcrumbData.push(BCMainStocks);
        this.setState({
            breadcrumb: breadcrumbData
        });
    }

    requestIndexes() {
        this.props.getIndexes();
    }

    requestStocks(selectedMarket) {
        this.handleSelectorChange({ selectedMarket });
    }

    render() {
        const { immBrokerExchangeIndexes, immTodaysMainStocks, immFlagBasedFeatures } = this.props;
        const { selectedMarket } = this.state;
        const allowedRiskIndicator = immFlagBasedFeatures.get('landing_risk_indicator');
        return (
            <div className="broker-main-stocks-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.state.breadcrumb}
                        finalTitle={getFinalTitle('broker-mainStocksTitle')}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            to={MYPROFILE_BROKER_EXPLORE_STOCKS_URL}
                            loading={false}
                        >
                            <FormattedText value="broker-mainStocksGoToSearch" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-main-stocks-view__body">
                    <div className="row no-outside-gutter">
                        <section className="col-xs-12">
                            { allowedRiskIndicator&&
                                <div className="broker-main-stocks-view__risk">
                                    <BrokerRiskInformationBox riskType={BROKER_RISK_TYPE_SIX} />
                                </div>
                            }
                            <OKSectionBox
                                title={formatText('broker-mainStocksByMarket')}
                            >
                                <BrokerMainStocksSelector
                                    immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                                    selectedMarket={selectedMarket}
                                    onChange={this.handleSelectorChange}
                                    requestIndexes={this.requestIndexes}
                                />
                            </OKSectionBox>

                            <BrokerMainStocksResultsList
                                immTodaysMainStocks={immTodaysMainStocks}
                                selectedMarket={selectedMarket}
                                requestStocks={this.requestStocks}
                                selectedTab={immTodaysMainStocks.get('showMoreSelectedTab')}
                                immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                            />
                        </section>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerMainStocksView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immTodaysMainStocks: PropTypes.object.isRequired,
    getIndexes: PropTypes.func.isRequired,
    getRisersAndFallers: PropTypes.func.isRequired,
    resetShowMoreSelectedTab: PropTypes.func.isRequired
};

module.exports.constructor = BrokerMainStocksView;
module.exports.BrokerMainStocksView = connect(
    state => ({
        immBrokerExchangeIndexes: state.brokerExchangeIndexes,
        immTodaysMainStocks: state.brokerTodaysMainStocks,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
        getRisersAndFallers: brokerTodaysMainStocksActions.getRisersAndFallers,
        getIndexes: brokerTodaysMainStocksActions.getIndexes,
        resetShowMoreSelectedTab: brokerTodaysMainStocksActions.resetShowMoreSelectedTab
    }
)(withRouter(BrokerMainStocksView));
